import { Footer } from "components/Footer";
import { HeaderWithNav } from "components/HeaderWithNav";
import { HeroSection } from "components/HeroSection";
import { useDynamicLanguage } from "hooks/useDynamicLanguage";
import heroImage from "assets/images/solutions-hero.png";
import { GetStartedSection } from "components/GetStartedSection";
import cardImage2 from "assets/images/solution-image2.png";
import { TextImageSection } from "pages/Products/components/TextImageSection";
import { HowItWorks } from "./components/HowItWorks";
import { LOCALE_STRINGS } from "constants/locales";
import { useScrollToElement } from "hooks/useScrollToElement";
import { TextSection } from "./components/TextSection";

export const Solutions = () => {
  const language = useDynamicLanguage();
  useScrollToElement();

  return (
    <>
      <HeaderWithNav />
      <div id="page" />
      <main className="main-content-wrapper home-page__main">
        <HeroSection
          imageSrc={heroImage}
          language={language}
          titleKey={"hero_solutionsTitle"}
          descriptionKey={"hero_solutionsDescription"}
        />
        <TextSection
          title="Our Solutions"
          className="pt-24 pb-10 px-10 mt-6 w-full flex justify-center"
        />

        <TextSection
          title="Trade - Source Globally, Trade With Certainty"
          content="Our trade solution gives African importers direct access to pre-vetted global suppliers, with Ezer acting as principal on every transaction. This means buyers deal with a single, trusted counterparty — eliminating supplier risk — while benefiting from Ezer's established procurement relationships and commodity sourcing expertise."
          contentNext="Automated contract management and real-time logistics visibility handle the operational complexity, so importers can focus on their business."
        />

        <TextSection
          title="Finance — Data-Driven Trade Credit Solutions"
          content="Unlike traditional lenders who rely on static financial statements, Ezer Finance uses real-time transaction intelligence — payment behavior, shipment performance, and order history — to extend credit to businesses that banks routinely overlook."
        >
          <div className="grid md:grid-cols-2 gap-8 mt-10">
            <div className="p-8 border rounded-xl bg-white/5 transition-hover hover:border-primary">
              <h4 className="mb-3 font-semibold text-xl">
                Pre-Shipment Financing
              </h4>
              <p className="text-image-section-paragraph mb-3">
                Revolving trade credit lines for importers and exporters to fund
                purchases and production costs before goods are shipped.
              </p>
            </div>

            <div className="p-8 border rounded-xl bg-white/5 transition-hover hover:border-primary">
              <h4 className="mb-3 font-semibold text-xl">
                Post-Shipment Financing
              </h4>
              <p className="text-image-section-paragraph">
                Invoice factoring and receivables financing that give exporters
                immediate liquidity against outstanding invoices.
              </p>
            </div>
          </div>
        </TextSection>

        <HowItWorks language={language} />

        <TextSection
          title="Pay — Cross-Border Payments Built for African Trade"
          content="Moving money across borders shouldn't slow trade down. Ezer Pay embeds payment infrastructure directly into the trade workflow — so settlements move automatically with purchase orders, invoices, and shipment milestones, not days behind them."
          contentNext="Importers and exporters transact in their preferred local currencies, eliminating costly conversion friction, while fully regulated processing through licensed partners ensures AML and KYC compliance without the administrative overhead. The result is faster settlement, lower transaction costs, and cash flow that's predictable for every party in the chain."
        />

        <GetStartedSection language={language} />
      </main>
      <Footer />
    </>
  );
};
